var Share = {
    checkCount: function (options) {
        $.ajax({
            url: '/bet/checkCount/',
            data: {
                url: options.url
            },
            success: function(response) {
                var getType = {};

                if (response.success && parseInt(response.count) > 0) {
                    $(window).trigger('share.success');
                    if (options.success && getType.toString.call(options.success) === '[object Function]') {
                        options.success();
                    }
                } else {
                    $(window).trigger('share.error');
                    if (options.error && getType.toString.call(options.error) === '[object Function]') {
                        options.error();
                    }
                }
            }
        });
    },
    vk: function(options) {
        // url для расшаривания. Пока в Javascript SDK от контакта не будет мобильной вертски для метода wall.post
        // будем использовать такой костыль
        var url = 'https://vk.com/share.php?' + 'url=' + encodeURIComponent(options.url) + '&title=' + encodeURIComponent(options.title) + '&description=' + encodeURIComponent(options.description) + '&image=' + encodeURIComponent(options.image) + '&noparse=false';
        var self = this;

        this.openPopup(url);

        // Когда окно закрыто мы должны узнать запостил ли ссылку пользователь.
        // Проверяем просто по кол-ву расшариваний ссылки, она ведь уникальная
        $(window).on('share.window.closed', function() {
            self.checkCount(options);
            // $.ajax({
            //     url: '/bet/checkCount/',
            //     data: {
            //         url: options.url
            //     },
            //     success: function(response) {
            //         var getType = {};
            //
            //         if (response.success && parseInt(response.count) > 0) {
            //             $(window).trigger('share.success');
            //             if (options.success && getType.toString.call(options.success) === '[object Function]') {
            //                 options.success();
            //             }
            //         } else {
            //             $(window).trigger('share.error');
            //             if (options.error && getType.toString.call(options.error) === '[object Function]') {
            //                 options.error();
            //             }
            //         }
            //     }
            // });
        });
    },

    // У Facebook все красиво, поэтому просто используем их метод из SDK.
    // Из-за этого не поддерживается событие закрытия окна
    // Событие об успешном расшаривании приходит через postMessage, если найти способ как заставить их всегда его отдавать
    // то от SDK можно было отказаться.
    // Ссылка для расшаривания:
    // 'https://www.facebook.com/dialog/feed?'
    // + '&app_id=865009010178606'
    // + '&display=popup'
    // + '&link='            + encodeURIComponent(options.url)
    // + '&caption='         + encodeURIComponent('Турбазар. Отдых по твоей цене.')
    // + '&name='            + encodeURIComponent(options.title)
    // + '&picture='         + encodeURIComponent(options.image)
    // + '&description='     + encodeURIComponent(options.description);
    fb: function(options) {
        var url = 'https://www.facebook.com/dialog/feed?'
            + '&app_id=865009010178606'
            + '&display=popup'
            + '&link='            + encodeURIComponent(options.url)
            + '&caption='         + encodeURIComponent(options.caption)
            + '&name='            + encodeURIComponent(options.title)
            + '&picture='         + encodeURIComponent(options.image)
            + '&description='     + encodeURIComponent(options.description);

        var self = this;

        $(window).on('share.window.closed', function() {
            self.checkCount(options);
        });

        this.openPopup(url);


        // var self = this;
        // FB.ui({
        //     method: 'feed',
        //     language: 'russian',
        //     name: options.title,
        //     caption: options.caption,
        //     link: options.url,
        //     picture: options.image,
        //     description: options.description
        // }, function(response) {
        //     var getType = {};
        //
        //     if (response && (response.post_id || (response instanceof Array))) {
        //         self.checkCount(options);
        //     } else {
        //         $(window).trigger('share.error');
        //         if (options.error && getType.toString.call(options.error) === '[object Function]') {
        //             options.error();
        //         }
        //     }
        //     //     $(window).trigger('share.success');
        //     //     if (options.success && getType.toString.call(options.success) === '[object Function]') {
        //     //         options.success();
        //     //     }
        //     // } else {
        //     //     $(window).trigger('share.error');
        //     //     if (options.error && getType.toString.call(options.error) === '[object Function]') {
        //     //         options.error();
        //     //     }
        //     // }
        // });
    },

    onOkMessage: function(e, options) {
        var originalEvent = e.originalEvent;
        var self = this;
        if (originalEvent.origin != 'https://connect.ok.ru' || originalEvent.data == 'loaded') {
            return;
        }

        // Успешный ответ на ИОС почему-то обрезается.
        // Поэтому считаем что если явно не указана ошибка, то все прошло успешно
        try {
            var response = $.parseJSON(originalEvent.data);
            if (response.error) {
                $(window).trigger('share.error');
                return;
            }
        } catch (err) {

        }

        self.checkCount(options);

        // $(window).trigger('share.success');
    },

    // Сам текст жсона приходит вместе ссылкой на ставку, там же подпись запроса
    ok: function(options) {
        var _this = this;
        $(window).on('message', function (e) {
            _this.onOkMessage(e, options)
        });

        //$(window).on('share.window.closed', function() {
        //  $(window).trigger('share.error');
        //});

        // $(window).on('share.success', function() {
            // console.log('share success');
            // _this.checkCount(options);
            // var getType = {};
            // if (options.success && getType.toString.call(options.success) === '[object Function]') {
            //     options.success();
            // }
        // });

        $(window).on('share.error', function() {
            // _this.checkCount(options);
            var getType = {};
            $(window).off('message', _this.onOkMessage);
            if (options.error && getType.toString.call(options.error) === '[object Function]') {
                options.error();
            }
        });

        var url = 'http://connect.ok.ru/dk?st.cmd=WidgetMediatopicPost' + '&st.app=1105096448' + '&st.attachment=' + encodeURIComponent(options.ok.json) + '&st.signature=' + options.ok.sign + '&st.silent=on';

        this.openPopup(url);
    },

    openPopup: function(url) {
        var popup = window.open(url, '', 'toolbar=0,status=0,scrollbars=1,width=626,height=436');
        if (!popup) {

        }

        var interval = setInterval(function() {
            try {
                if (popup == null || popup.closed) {
                    clearInterval(interval);
                    // Генерим событие что окно закрыто
                    $(window).trigger('share.window.closed');
                }
            } catch (e) {}
        }, 500);
    }
};
